import { useState } from 'react';
import { supabase } from '../../supabase';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
//Hasło
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import '../../styles/Login.css';

import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";

export default function Login() {
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [notification, setNotification] = useState('');
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(FaRegEyeSlash);
  const nav = useNavigate();

  const handleToggle = () => {
   if (type==='password'){
      setIcon(FaRegEye);
      setType('text')
   } else {
      setIcon(FaRegEyeSlash);
      setType('password')
   }
}

  const signIn = async (e) => {
    e.preventDefault();
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password
    });
    if(error) { setNotification("Błędny email lub hasło"); return; }
    nav("/online");
  }

  return (
    <div>
      <ProjectHeader
        headerTitle={'Logowanie'}
        showBackButton={true}
        path={"/"}
      />
      <div className="LoggingForm">
        <form>
          <input type="email" placeholder="email" onChange={e=>setEmail(e.target.value)}/> <br/>
          <div className="password-container"> 
            <input type={type} placeholder="hasło" onChange={e=>setPassword(e.target.value)}/>
            <span onClick={handleToggle}>
              <span className="toggle-icon"> 
                {icon}
              </span>
            </span>
          </div>
          
          <button type="button" onClick={signIn}>Zaloguj</button> <br/>
          <p style = {{color: "red"}}> {notification} </p>
          Nie masz jeszcze konta? <Link to="/registration">Załóż je!</Link>

        </form>
      </div>
    </div>
  );
}